var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { Wrapper } from 'app/components/styles/districtModules/headerStyles';
import { FONTS, Image, ImageEntity, SIZES, Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
import { Heading } from 'app/components/competitionModule/header/headerStyles';
import SponsorAdSlot from 'app/components/ads/SponsorAdSlot';
import { useSelector } from 'react-redux';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
const ImageContainer = styled.div.withConfig({
  componentId: "sc-1u4j4s6-0"
})(["display:flex;justify-content:center;align-items:center;height:", ";width:", ";margin-right:", ";"], SIZES['32'], SIZES['32'], SIZES['8']);
const Title = styled(Typography).withConfig({
  componentId: "sc-1u4j4s6-1"
})(["&&&{", "}"], props => props.theme.streamModuleFourElemsPerViews(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        font-size: ", ";\n        line-height: ", ";\n      "])), FONTS['18'], SIZES['24']));
export default function CompetitionModuleHeader(_ref) {
  var _district$region;
  let {
    data
  } = _ref;
  // To prevent unfilled AIs, AdSlot is only placed on region='niederbayern', template='region_index'
  // template='region_index' is ensured by component usage on DistrictMainPage
  // region='niederbayern' is ensured by selectDistrict functionality
  // ⚠️Warn: In the future, if the component is reused on other pages, the condition must be checked and adjusted if necessary
  const district = useSelector(reduxSelectDistrict);
  const isRegionNiederbayern = (district === null || district === void 0 || (_district$region = district.region) === null || _district$region === void 0 ? void 0 : _district$region.slug) === 'niederbayern';
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "CompetitionModuleHeader",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Competition,
    src: data.image,
    ratio: "1:1",
    width: 32,
    height: 32,
    fit: true,
    "data-sentry-element": "Image",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  })), /*#__PURE__*/React.createElement(Heading, {
    to: data.getLinkToCompetition(),
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(Title, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "CompetitionModuleHeader.tsx"
  }, data.longName)), isRegionNiederbayern && /*#__PURE__*/React.createElement(SponsorAdSlot, {
    extendSlotId: data.id
  }));
}